import { Directive, EventEmitter, Host, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appItemDropper]'
})
export class ItemDropperDirective {

  @Output() itemDrop = new EventEmitter();
  @Output() itemHov = new EventEmitter();
  @Output() hov = new EventEmitter();
  @Output() dragEnd = new EventEmitter();

  content: any;

  constructor() { }

  @HostListener('drop', ['$event'])
  onDrop($event) {
    //console.log('directive says... DROP!', $event)
    this.itemDrop.emit(true)
  }

  @HostListener('dragover', ['$event'])
  onDragOver($event) {
    $event.preventDefault();
    this.itemHov.emit(true);
    let id = this.getParentWithId($event.target);
    if(!!id){
      let elem = document.getElementById(id).getBoundingClientRect();
      this.hov.emit(
        {
          x: $event.clientX,
          y: $event.clientY,
          id: this.getParentWithId($event.target),
          zone: $event.clientY > elem.y + (elem.height / 2) ? 'bottom' : 'top'
        }
      )
    }
  }
  
  @HostListener('dragend',['$event'])
  onDragEnd($event){
    this.dragEnd.emit($event)
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave($event) {
    $event.preventDefault();
    this.itemHov.emit(false);
  }

  getParentWithId(p:HTMLElement){
    if(!p) return null
    if(!!p && !!p.id) { return p.id }
    return this.getParentWithId(p.parentNode as HTMLElement);
  }
}
